import { render, staticRenderFns } from "./crud_cost_centre.vue?vue&type=template&id=81b71708&scoped=true"
import script from "./crud_cost_centre.vue?vue&type=script&lang=js"
export * from "./crud_cost_centre.vue?vue&type=script&lang=js"
import style0 from "./crud_cost_centre.vue?vue&type=style&index=0&id=81b71708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b71708",
  null
  
)

export default component.exports